import { SxProps, Theme } from '@mui/material';

export const editDialogStyle = {
  '.MuiDialog-paper': {
    background: (t) => t.palette.grey[600],
    '>div': { bgcolor: 'transparent' },
  },
} satisfies SxProps<Theme>;
